import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

import Presentation from './Presentation';
import Horaires from './Horaires';
import Photos from './Photos';
import Carte from './Carte';
import Tarifs from './Tarifs';
import Contact from './Contact';

const roads = [
    {
        path: '/',
        id: 'presentation',
        animation: 'presentation',
        Component: Presentation
    },
    {
        path: '/horaires',
        id: 'horaires',
        animation: 'horaires',
        Component: Horaires
    },
    {
        path: '/photos',
        id: 'photos',
        animation: 'photos',
        Component: Photos
    },
    {
        path: '/carte',
        id: 'carte',
        animation: 'carte',
        Component: Carte
    },
    {
        path: '/tarifs',
        id: 'tarifs',
        animation: 'tarif',
        Component: Tarifs
    },
    {
        path: '/contact',
        id: 'contact',
        animation: 'contact',
        Component: Contact
    }
]

const MainContent= () => {
    // use location hook
    const location = useLocation();

    // location local state
    const [displayLocation, setDisplayLocation] = useState(location);

    // transitions state
    const [transitionStage, setTransistionStage] = useState("fadeIn");

    useEffect(() => {
        if (location !== displayLocation) setTransistionStage("fadeOut");
    }, [location, displayLocation]);

    const handleAnimationEnd = (event) => {
        if (transitionStage === "fadeOut") {
            setTransistionStage("fadeIn");
            setDisplayLocation(location);
        }
    }

    return(    
        <> 
        {
            roads.map((Road, index) => (
                <div
                    key={index}
                    id={Road.id}
                    className={`${transitionStage}`}
                    onAnimationEnd={handleAnimationEnd}
                >
                    <Routes location={displayLocation}>
                        <Route exact path={Road.path} element={<Road.Component />} />
                    </Routes>
                </div>
            ))
        }
        </>
    );
};

export default MainContent;